import { createStyles } from '@mantine/styles';

var useStyles = createStyles(() => ({
  close: {
    marginLeft: "auto",
    marginRight: 0
  }
}));

export default useStyles;
//# sourceMappingURL=ModalBaseCloseButton.styles.js.map
